
import {getApps,GetApps_new} from '@/assets/js/api/home'
const home = {
  state: {
    apps:[],
    model:{nines:[]}
  },
  actions: {
    loadApps({ commit },params) {
      GetApps_new(params).then(res => {
        commit('SET_APPS', res.data.data)
      })
    },
    getModel ({ commit },agentid) {
      return new Promise((resolve, reject) => {
        getApps({agentid:agentid}).then(response=>{
          if(response.data.result){
            commit('SET_MODEL', response.data.data)
          }
          resolve(response.data.result)
        })
      })
    },
  },
  mutations: {
    SET_APPS(state, apps) {
      state.apps = apps
    },
    SET_MODEL (state, data) {
      state.model = data
    }
  },
  namespaced: true
}

export default home



// WEBPACK FOOTER //
// ./src/store/modules/home.js